import { h as r } from "./has-own-property.js";
var a = function a(_a) {
  return void 0 !== _a && (r(_a, "value") || r(_a, "writable"));
};
export { a as i };